import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 22 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.75 6a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0M5 6a6 6 0 1 1 12 0A6 6 0 0 1 5 6M2.81 21.75h16.38a6.11 6.11 0 0 0-6.048-5.25H8.858a6.11 6.11 0 0 0-6.047 5.25Zm-2.31.858a8.356 8.356 0 0 1 8.358-8.358h4.284a8.356 8.356 0 0 1 8.358 8.358c0 .769-.623 1.392-1.392 1.392H1.892A1.39 1.39 0 0 1 .5 22.608" }, null, -1)
  ]))]))
}
export default { render: render }